import React, { type ReactNode } from 'react';
import { SidebarMobileDropdownMenu } from '@/layout/SidebarLayout/SidebarMobileDropdownMenu';
import { useProfileSidebarMenu } from './useProfileSidebarMenu';
export const ProfileTitleWithMenus = (props: {
  title: ReactNode;
  className?: string;
  hideMobileDropdown?: boolean;
}) => {
  const {
    menus,
    footerMenus
  } = useProfileSidebarMenu();
  return <SidebarMobileDropdownMenu title={props.title} menus={[...menus, ...footerMenus]} className={props.className} hideMobileDropdown={props.hideMobileDropdown} data-sentry-element="SidebarMobileDropdownMenu" data-sentry-component="ProfileTitleWithMenus" data-sentry-source-file="ProfileTitleWithMenus.tsx" />;
};